<base-support-modal [title]="title" [btnOkClass]="'btn-success'" [btnOkLabel]="'Применить'" (onOk)="ok()" >
	<div [formGroup]="form">
		<p>Осталось триала: <span class="badge badge-warning">{{trialExpiration !== 0 ? trialExpiration : '&mdash;'}}</span></p>
		<div class="js-ul-radio-group">
			<div class="radio">
				<label for="addDaysRadio">
					<input type="radio" [ngModelOptions]="{standalone: true}" name="rtfsFilter" id="addDaysRadio" class="js-ul-radio-group-label" [(ngModel)]="rtfsFilter" value="addDays">
					Добавить дней к триалу:
				</label>
			</div>
	
			<div class="form-group">
				<input type="number" formControlName="addDays" min="1" name="addDays" id="addDays" ul-model="addDays" class="form-control js-ul-radio-group-input" [(ngModel)]="addDays" [disabled]="rtfsFilter=='dateTrialStart'" autocomplete="off" value="1">
			</div>
		</div>
	
		<div class="js-ul-radio-group">
			<div class="radio">
				<label for="newDateRadio">
					<input type="radio" [ngModelOptions]="{standalone: true}" name="rtfsFilter" id="newDateRadio" [(ngModel)]="rtfsFilter" value="dateTrialStart">
					Новая дата начала триала:
				</label>
			</div>
	
			<div class="form-group">
				<datepicker formControlName="dateTrialStart" [(ngModel)]="dateTrialStart" [disabled]="rtfsFilter=='addDays'" [disabledPast]="false"></datepicker>
			</div>
		</div>
	</div>
</base-support-modal>
